/*
 * @message:
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-06-30 16:09:27
 * @FilePath: \mrc-ess-fronted\src\util\func.js
 * @最后编辑: Betway
 * @最后修改时间: 2022-03-02 14:33:33
 */

import _this from "../main.js";
import dayjs from "dayjs";
import store from "../store"; //狀態管理
const crypto = require("crypto"); //加密工具
import { KEYUTIL, KJUR, hextob64 } from "jsrsasign"; //登录加密使用
const hmac_key = "299cb5bb4c9040a29c58304c25001d72"; //加密密钥
import { getOsInfo, getBrowser } from "@/util/system";
//全局table配置
export const tableSetting = {
  perPageSize: 20, //每页预设条数
  pageCount: 10, //分页最多显示页数
};
//全局下拉框select显示数量配置
export const selectSetting = {
  maxChips: 2, //选项中最多显示个数
};
//全局avatar色彩配置,已经弃用
export const avatarColors = [
  "#637A88",
  "#3Fc9b3",
  "#289daa",
  "#66b4e7",
  "#4354b4",
  "#7c81fc",
  "#934ce0",
  "#aa3e90",
  "#fc8282",
  "#AA3E3E",
  "#ed7217",
  "#dbb016",
];
// .sort(() => Math.random() - 0.5);
//全局avatar色彩,用于全局头像背景
export const oneColors = "#9e9e9e";
// 2020-02-06 mel 802改为grey
// avatarColors[
//     Math.floor(Math.random() * Math.floor(avatarColors.length - 1))
//   ];
//全局可选色彩配置,这只是初始化默认颜色，会被common全局高级参照替换。
export const Colors = [
  { text: "Green", color: "#C4FAE0" },
  { text: "Dark Green", color: "#C0E1BB" },
  { text: "Sky Blue", color: "#BFF1FC" },
  { text: "Grey Blue", color: "#A3CFE4" },
  { text: "Blue", color: "#C8D4FF" },
  { text: "Soft Violet", color: "#EBD9FF" },
  { text: "Pink", color: "#FFD1F2" },
  { text: "Wine", color: "#F1C9D3" },
  { text: "Light Red", color: "#FFE8E8" },
  { text: "Orange", color: "#FFDCBB" },
  { text: "Yellow", color: "#FFE99A" },
  { text: "Grey", color: "#D5DAE8" },
  { text: "Grey Purple", color: "#EEE7F3" },
  { text: "Brown", color: "#E5C5A7" },
  { text: "Moderate Yellow", color: "#DEE1B8" },
];
// .sort(() => Math.random() - 0.5);
//获取标签颜色
export function getTagColors(colors, code) {
  const that = this;
  if (colors) {
    let color = colors.find((ele) => ele["value_field"] === code.toString());
    if (color) return color["f1"];
    else return "primary"; //主题颜色
  } else {
    return "primary"; //主题颜色
  }
}
// 进入全屏幕，暂没用，去掉了此功能
export function toggleFullScreen(full, el = window.document.documentElement) {
  const doc = window.document;
  const docEl = el;

  const requestFullScreen =
    docEl.requestFullscreen ||
    docEl.mozRequestFullScreen ||
    docEl.webkitRequestFullScreen ||
    docEl.msRequestFullscreen;
  const cancelFullScreen =
    doc.exitFullscreen ||
    doc.mozCancelFullScreen ||
    doc.webkitExitFullscreen ||
    doc.msExitFullscreen;
  if (
    !doc.fullscreenElement &&
    !doc.mozFullScreenElement &&
    !doc.webkitFullscreenElement &&
    !doc.msFullscreenElement &&
    full
  ) {
    requestFullScreen.call(docEl);
  } else {
    cancelFullScreen.call(doc);
  }
}
//页面跳转
export function toPage(Url, data, type = "push") {
  if (type == "push") {
    this.$router.push({ path: Url, query: data });
  }
  if (type == "replace") {
    this.$router.replace({ path: Url, query: data });
  }
}
// logz.io日志打印工具
var logger = require("logzio-nodejs").createLogger({
  token: "hLJmBKtSawmMZfBZuoZjcEtUnyyWrdtS",
  protocol: "https",
  host: "listener.logz.io",
  bufferSize: 1,
  port: "8071",
  type: "ess-front-web",
});
//打印日志
export function logZ(arg) {
  logger.log(arg);
}
// 金额数目千分位显示
export function get_thousand_num(num) {
  return num.toString().replace(/\d+/, function (n) {
    // 先提取整数部分
    return n.replace(/(\d)(?=(\d{3})+$)/g, function ($1) {
      // 对整数部分添加分隔符
      return $1 + ",";
    });
  });
}
//节流
export function throttle(fn, delay = 500, immediate = false) {
  let timer = null,
    immediateTimer = null,
    immediateRunning = !immediate;

  return function () {
    let context = this,
      args = arguments;

    if (immediate && !immediateRunning) {
      fn.apply(context, args);
      immediateRunning = true;
      // // 重置首次执行标识
      immediateTimer = setTimeout(() => {
        immediateRunning = false;
      }, delay);
      return;
    }

    if (!timer) {
      // 如果有后续触发，在定时器中取消immediateTimer
      if (immediateTimer) {
        clearTimeout(immediateTimer);
        immediateTimer = null;
      }
      timer = setTimeout(() => {
        fn.apply(context, args);
        timer = null;
        immediateTimer = setTimeout(() => {
          immediateRunning = false;
        }, delay);
      }, delay);
    }
  };
}
//全局From表单验证规则
var AllRules = {
  _Require_Rules: (name) => {
    return (v) =>
      !!v != 0 ||
      (name
        ? name + _this.$t("verify_essweb_form_textField_dataIsNullTextLabel")
        : _this.$t("verify_essweb_form_textField_dataCommonLabel") +
          _this.$t("verify_essweb_form_textField_textisNullTextLabel"));
  },
  _ImageSize_Rules: (name) => {
    return (value) =>
      (!value && value.size < 2000000) ||
      (name ? name : "data") + "size should be less than 2 MB!";
  },
  //数字正负验证
  _Number_negative: (name) => {
    return (v) =>
      Number(v) >= 0 ||
      (name ? name : _this.$t("verify_essweb_form_textField_dataCommonLabel")) +
        _this.$t("verify_essweb_form_textField_dataIsIllegalLabel");
  },
  //数字大小验证
  _Number_Max: (obj) => {
    return (v) =>
      (obj.number ? Number(v) <= Number(obj.number) : true) ||
      (obj?.name ?? _this.$t("verify_essweb_form_textField_dataCommonLabel")) +
        _this.$t("verify_essweb_form_textField_dataIsIllegalLabel");
  },
  //数字正负验证
  _Number_negative_reduce: (name) => {
    return (v) =>
      !isNaN(v) ||
      (name ? name : _this.$t("verify_essweb_form_textField_dataCommonLabel")) +
        _this.$t("verify_essweb_form_textField_dataIsIllegalLabel");
  },
  _Require_ArrRules: (name) => {
    return (v) =>
      !!v.length > 0 ||
      (name
        ? name + _this.$t("verify_essweb_form_textField_dataIsNullTextLabel")
        : _this.$t("verify_essweb_form_textField_textisNullTextLabel"));
  },
  _Length_Rules: (len) => {
    return (v) =>
      (v ? v.toString().length <= len : true) ||
      _this.$t("verify_essweb_form_textField_textOverLengthLabel") + len;
  },
  _SpecialCharacters_Rules: (name) => {
    var regEn = /[`~!@$%^&*()_+<>?:"{},.\/;'[\]]/im,
      regCn = /[·！￥（——）：；“”‘、，|《。》？、【】[\]]/im;
    return (v) =>
      (!regEn.test(v) && !regCn.test(v)) ||
      (name ? name : _this.$t("verify_essweb_form_textField_dataCommonLabel")) +
        _this.$t("verify_essweb_form_textField_dataIsIllegalLabel");
  },
  _Email_Rules: (email) => {
    return (v) =>
      /.+@.+\..+/.test(v) ||
      (email
        ? email
        : _this.$t("verify_essweb_form_textField_dataCommonLabel")) +
        _this.$t("verify_essweb_form_textField_dataIsIllegalLabel");
  },
};
//
export function GetRules(rules, args = []) {
  if (_this == undefined) return [];
  // rules String/Array
  // args Array/String
  //*每一个rule接收一个参数
  // 没有参数用null
  var Rules = [];
  if (typeof rules === "string") {
    Rules.push(
      AllRules[rules]
        ? AllRules[rules](typeof args === "object" ? args[0] : args)
        : false
    );
  } else if (typeof rules === "object") {
    rules.forEach(function (item, index) {
      // if ((item = "_Length_Rules")) {
      // } else {
      if (AllRules[item]) {
        Rules.push(AllRules[item](args[index]));
      }
      // }
    });
  } else {
    Rules = [];
  }

  return Rules;
}
//根据类型生成默认值
export function defaultInitValue(type, value) {
  if (!type) return value === undefined ? null : value;
  type = String(type);
  let str = "";
  switch (type) {
    case "string":
      str = value === undefined ? "" : value;
      break;
    case "text":
      str = value === undefined ? "" : value;
      break;
    case "double":
      str = value === undefined ? 0 : Number(value);
      break;
    case "int":
      str = value === undefined ? 0 : Number(value);
      break;
    case "datetime":
      str =
        value === undefined
          ? ""
          : this.$getDateTime(Number(value), "YYYY-MM-DD HH:MM");
      break;
    case "date":
      str =
        value === undefined
          ? ""
          : this.$getDateTime(Number(value), "YYYY-MM-DD");
      break;
    case "month":
      str = value === undefined ? "" : value;
      break;
    case "file":
      str = value === undefined ? [] : value;
      break;
    case "files":
      str = value === undefined ? [] : value;
      break;
    case "year":
      str = value === undefined ? "" : value;
      break;
    case "boolean":
      str = value === undefined ? false : value ? true : false;
      break;
    default:
      str = value === undefined ? null : value;
      break;
  }
  return str;
}
//根据类型判断是否改变默认值
export function isEqualInitValue(type, value, initValue) {
  if (!type) return value === initValue;
  value = value === null ? (value = "") : value;
  initValue = initValue === null ? (initValue = "") : initValue;
  type = String(type);
  let equal = false;
  switch (type) {
    case "string":
      equal = value.toString() === initValue.toString();
      break;
    case "text":
      equal = value.toString() === initValue.toString();
      break;
    case "double":
      equal = Number(value) === Number(initValue);
      break;
    case "datetime":
      equal = value.toString() === initValue.toString();
      break;
    case "date":
      equal = value.toString() === initValue.toString();
      break;
    case "date":
      equal = value.toString() === initValue.toString();
      break;
    case "file":
      equal = value === null || value === "";
      break;
    case "files":
      equal = value.length || initValue.length;
      break;
    case "year":
      equal = value.toString() === initValue.toString();
      break;
    case "boolean":
      equal = value === initValue;
      break;
    default:
      equal = value === initValue;
      break;
  }
  return equal;
}
////消息提示框
export function showMessage(status) {
  switch (status["type"]) {
    case "warning":
      confirmWarn(
        status["title"]
          ? status["title"]
          : _this.$t("message_essweb_form_textField_notIncorrect_title"),
        status.text,
        status["cancelText"] ? status["cancelText"] : null,
        status["okText"] ? status["okText"] : null,
        status["showConfirm"] !== undefined ? status["showConfirm"] : true,
        status["showCancel"] !== undefined ? status["showCancel"] : false
      );
      break;
    case "success":
      status["color"] = "black";
      store.dispatch("showMessage", status);
      break;
    case "error":
      confirmWarn(
        status["title"]
          ? status["title"]
          : _this.$t("message_essweb_form_submit_errorTitle"),
        status.text,
        status["cancelText"] ? status["cancelText"] : null,
        status["okText"] ? status["okText"] : null,
        status["showConfirm"] !== undefined ? status["showConfirm"] : true,
        status["showCancel"] !== undefined ? status["showCancel"] : false
      );
      break;
    default:
      break;
  }
}
// 隐藏消息提示
export function hideMessage() {
  store.dispatch("hideMessage");
}

//分钟数转时间格式
export function timeMachine(time, format = false, standard) {
  if (_this == undefined) return "";
  if (time === "" || time === null) return "";
  let logic = 1;
  if (time < 0) logic = -1;
  // time = Math.abs(time);
  let stand = 24 * 60;
  let defaultLang = _this ? store.getters.defaultLang : "en";
  if (standard != undefined) {
    stand = Number(standard);
  }
  var day = 0;
  var hour = 0;
  var minute = 0;
  if (time >= 0) {
    day = Math.floor(Number(time) / stand);
    hour = Math.floor((Number(time) - day * stand) / 60);
    minute = Number(time) - day * stand - hour * 60;
  } else {
    day = Math.floor(Number(time) / stand);
    hour = Math.floor((Number(time) - day * stand) / 60);
    minute = Number(time) - day * stand - hour * 60;
  }
  if (format && defaultLang) {
    let str = "";
    if (day > 0) {
      str +=
        day +
        (day > 1
          ? _this.$t("label_essweb_system_dayLabel")
          : _this.$t("label_essweb_system_dayLabel"));
      if (hour > 0)
        str +=
          hour +
          (hour > 1
            ? _this.$t("label_essweb_system_hourLabel")
            : _this.$t("label_essweb_system_hourLabel"));
      if (minute > 0)
        str +=
          minute +
          (minute > 1
            ? _this.$t("label_essweb_system_minutesLabel")
            : _this.$t("label_essweb_system_minutesLabel"));
    } else if (day < 0) {
      str +=
        day +
        (day > 1
          ? _this.$t("label_essweb_system_dayLabel")
          : _this.$t("label_essweb_system_dayLabel"));
      if (hour > 0)
        str +=
          hour +
          (hour > 1
            ? _this.$t("label_essweb_system_hourLabel")
            : _this.$t("label_essweb_system_hourLabel"));
      if (minute > 0)
        str +=
          minute +
          (minute > 1
            ? _this.$t("label_essweb_system_minutesLabel")
            : _this.$t("label_essweb_system_minutesLabel"));
    } else {
      if (hour > 0) {
        str +=
          hour +
          (hour > 1
            ? _this.$t("label_essweb_system_hourLabel")
            : _this.$t("label_essweb_system_hourLabel"));
        if (minute > 0)
          str +=
            minute +
            (minute > 1
              ? _this.$t("label_essweb_system_minutesLabel")
              : _this.$t("label_essweb_system_minutesLabel"));
      } else {
        str +=
          minute +
          (minute > 1
            ? _this.$t("label_essweb_system_minutesLabel")
            : _this.$t("label_essweb_system_minutesLabel"));
      }
    }
    return str;
  } else {
    return day == 0
      ? (hour >= 10 ? hour : "0" + hour) +
          ":" +
          (minute >= 10 ? minute : "0" + minute)
      : logic < 0
      ? "(" +
        day +
        ")" +
        (hour >= 10 ? hour : "0" + hour) +
        ":" +
        (minute >= 10 ? minute : "0" + minute)
      : "(+" +
        day +
        ")" +
        (hour >= 10 ? hour : "0" + hour) +
        ":" +
        (minute >= 10 ? minute : "0" + minute);
  }
}

//时区配置，会被base配置初始化
export const staticUTC = [
  { text: "UTC", utc: "0" },
  { text: "UTC+1", utc: (60 * 1).toString() },
  { text: "UTC+2", utc: (60 * 2).toString() },
  { text: "UTC+3", utc: (60 * 3).toString() },
  { text: "UTC+4", utc: (60 * 4).toString() },
  { text: "UTC+5", utc: (60 * 5).toString() },
  { text: "UTC+6", utc: (60 * 6).toString() },
  { text: "UTC+7", utc: (60 * 7).toString() },
  { text: "UTC+8", utc: (60 * 8).toString() },
  { text: "UTC+9", utc: (60 * 9).toString() },
  { text: "UTC+10", utc: (60 * 10).toString() },
  { text: "UTC+11", utc: (60 * 11).toString() },
  { text: "东西十二区", utc: (60 * 12).toString() },
  { text: "UTC-1", utc: (-60 * 1).toString() },
  { text: "UTC-2", utc: (-60 * 2).toString() },
  { text: "UTC-3", utc: (-60 * 3).toString() },
  { text: "UTC-4", utc: (-60 * 4).toString() },
  { text: "UTC-5", utc: (-60 * 5).toString() },
  { text: "UTC-6", utc: (-60 * 6).toString() },
  { text: "UTC-7", utc: (-60 * 7).toString() },
  { text: "UTC-8", utc: (-60 * 8).toString() },
  { text: "UTC-9", utc: (-60 * 9).toString() },
  { text: "UTC-10", utc: (-60 * 10).toString() },
  { text: "UTC-11", utc: (-60 * 11).toString() },
];
// 获取时区表达名称
export function getUtcByCode(code) {
  if (code === 0) return staticUTC[0].text;
  if (code === "") return "";
  if (!code) return "";
  var utc = staticUTC.filter((ele) => ele.utc === code.toString());
  if (utc.length) {
    return utc[0].text;
  } else {
    return "Unresolvable Time Zone"; //need trans
  }
}
//时间加时区，转换为固定时区的时间
export function getUtcTime(datetime, utc) {
  let t = new Date();
  let t_s;
  if (datetime == "" || datetime == null) return "";
  if (typeof datetime == "string") {
    t = new Date(datetime); //你已知的时间
    t_s = t.getTime(); //转化为时间戳毫秒数
  } else {
    t_s = datetime;
  }
  return dayjs(t.setTime(t_s + 1000 * 60 * Number(utc))).format(
    "YYYY/MM/DD HH:mm:ss"
  );
}
//获取时间cuo
export function getTimeValue(datetime, type = "") {
  if (datetime == "") return "";
  if (type == "claim") {
    // 判断设备
    if (getBrowser() === "Safari") {
      datetime = datetime.replace(/\-/g, "/");
      return new Date(datetime).getTime();
    }
    return new Date(datetime + " 00:00:00").getTime();
  } else if (type == "leave") {
    //请假和代理请假特殊
    if (getBrowser() === "Safari") {
      datetime = datetime.replace(/\-/g, "/");
      return new Date(datetime).getTime();
    }
    return new Date(datetime).getTime();
  } else {
    // 判断设备
    if (getBrowser() === "Safari") {
      datetime = datetime.replace(/\-/g, "/");
      return (
        new Date(datetime).getTime() -
        new Date().getTimezoneOffset() * 60 * 1000
      );
    }

    return new Date(datetime).getTime();
  }
}
//获取对应格式的时间string
export function getDateTime(datetime, format) {
  if (datetime == "") return format == "HH:mm" ? "-- : --" : "";
  if (!datetime) return format == "HH:mm" ? "-- : --" : "";

  return dayjs(datetime).format(format);
}
// 存储当前历史记录点,实现控制手机物理返回键的按钮事件
export function pushHistory() {
  let state = { title: "", url: "" };
  window.history.pushState(state, state.title, state.url);
}
//数组分组
export function chunkArr(arr, size) {
  if (arr == []) return [];
  var result = [];
  for (var i = 0, len = arr.length; i < len; i += size) {
    result.push(arr.slice(i, i + size));
  }
  return result;
}

//数组去重
export function UniqueArry(array, isSorted) {
  var res = [];
  var seen = [];

  for (var i = 0, len = array.length; i < len; i++) {
    var value = array[i];
    if (isSorted) {
      if (!i || seen !== value) {
        res.push(value);
      }
      seen = value;
    } else if (res.indexOf(value) === -1) {
      res.push(value);
    }
  }
  return res;
}
//获取默认语言对应的值
export function getCommonLangValue(langobj) {
  let defaultLang = store.getters.defaultLang
    ? store.getters.defaultLang
    : "en";
  let value = "";
  if (!langobj) return "";
  if (typeof langobj == "string") {
    return langobj;
  }
  langobj.some((item) => {
    for (let key in item) {
      if (key == defaultLang) {
        value = item[key];
        return true;
      }
    }
  });
  return value;
}
//获取公共语言key
export function getCommonLangKey(langobj) {
  if (_this != undefined && !langobj) {
    langobj = store.getters.companyLang;
  }
  var obj = {};
  langobj.forEach(function (item) {
    obj[item.value] = "";
  });
  return obj;
}
//转换成服务端支持的类型
export function transCommonLangKey(json, editjson) {
  let obj = [];
  for (let key in json) {
    let j = {};
    j[key] = json[key];
    if (editjson) {
      editjson.some((item) => {
        for (let key2 in item) {
          if (key2 === key) {
            j["uuid"] = item["uuid"];
            return true;
          }
        }
      });
    }
    obj.push(j);
  }
  return obj;
}
//转换成前端支持的类型
export function transOnLineCommonLangKey(langobj, obj) {
  var localjson = {};
  langobj.forEach(function (item) {
    localjson[item.value] = "";
  });
  for (let key in localjson) {
    if (typeof obj == "string") {
      localjson[key] = obj;
    } else {
      obj.some((it) => {
        for (let key2 in it) {
          if (key2 === key) {
            localjson[key] = it[key2];
            // return true;
          }
        }
      });
    }
  }
  return localjson;
}
//翻译下拉组件，对下拉数据某一个显示字段翻译，与计算属性搭配使用
export function getSelectTrans(data, arg) {
  if (data.length <= 0 || !data) return [];
  //深拷贝
  let arr = JSON.parse(JSON.stringify(data));
  arr.map((item) => {
    item[arg] = getCommonLangValue(item[arg]);
  });
  return arr;
}
// 全局返回
export function toBack(changed) {
  store.dispatch("setPageChange", false);
  if (changed) {
    confirmWarn(
      _this.$t("message_tips"),
      _this.$t("message_essweb_form_textField_refuseChange_title")
    ).then((res) => {
      if (res) {
        _this.$router.back();
        //  window.removeEventListener("popstate");
      }
    });
  } else {
    _this.$router.back();
    //  window.removeEventListener("popstate");
  }
}
// 列表排序
/*
items 数组
pro 变量
desc 降序false/升序true
type 筛选类型
*/
export function sortList(items, prop, desc, type = "string") {
  let array = JSON.parse(JSON.stringify(items)); //深拷贝
  return new Promise((resolve, reject) => {
    ////排除不存在此字段的对象，输出在结果最后展示
    let arr1 = array.filter((ele) => ele[prop] === undefined);
    let arr2 = array.filter((ele) => ele[prop] !== undefined);
    if (type) {
      //有传类型
      if (type == "datetime") {
        //时间戳类型
        arr2 = arr2.sort((a, b) => {
          return desc
            ? new Date(a[prop]) - new Date(b[prop])
            : new Date(b[prop]) - new Date(a[prop]);
        });
      }
      if (type == "string" || type == "number") {
        //字符串类型&数字类型
        arr2 = arr2.sort((a, b) => {
          return desc
            ? a[prop] > b[prop]
              ? 1
              : -1
            : a[prop] < b[prop]
            ? 1
            : -1;
        });
      }
      resolve(arr2.concat(arr1));
    } else {
      //没有传类型
      resolve(array);
    }
  });
}
//将父子关系的数组转换成树形结构数据
export function translateDataToTree(
  data,
  code = "code",
  parentcode = "parentCode"
) {
  //没有父节点的数据
  let parents = data.filter(
    (value) => value[parentcode] == "undefined" || value[parentcode] == null
  );

  //有父节点的数据
  let children = data.filter(
    (value) => value[parentcode] !== "undefined" && value[parentcode] != null
  );

  //定义转换方法的具体实现
  let translator = (parents, children) => {
    //遍历父节点数据
    parents.forEach((parent) => {
      //遍历子节点数据
      children.forEach((current, index) => {
        //此时找到父节点对应的一个子节点
        if (current[parentcode] === parent[code]) {
          //对子节点数据进行深复制，这里只支持部分类型的数据深复制，对深复制不了解的童靴可以先去了解下深复制
          let temp = JSON.parse(JSON.stringify(children));
          //让当前子节点从temp中移除，temp作为新的子节点数据，这里是为了让递归时，子节点的遍历次数更少，如果父子关系的层级越多，越有利
          temp.splice(index, 1);
          //让当前子节点作为唯一的父节点，去递归查找其对应的子节点
          translator([current], temp);
          //把找到子节点放入父节点的children属性中
          typeof parent.children !== "undefined"
            ? parent.children.push(current)
            : (parent.children = [current]);
        }
      });
    });
  };
  //调用转换方法
  translator(parents, children);

  //返回最终的结果
  return parents;
}
//获取文字头像，暂未使用
export function getAvatar(
  type = 1,
  name = "",
  size = 36,
  background = "#e1e1e1",
  color = "#333",
  length = 2,
  fontSize = 14
) {
  let data = {
    type: type,
    name: name,
    size: size,
    background: background.replace("#", ""),
    color: color.replace("#", ""),
    length: length <= 2 ? length : 2,
    fontSize: fontSize,
  };
  if (data.type == 1) {
    return (
      "https://ui-avatars.com/api/?name=" +
      data.name +
      "&size=" +
      Number(data.size) +
      "&font-size=" +
      Number(data.fontSize) +
      "&background=" +
      data.background +
      "&color=" +
      data.color +
      "&length=" +
      data.length
    );
  }
  if (data.type == 2) {
    if (data.name.length < data.length) {
      return data.name;
    } else {
      return data.name.substring(0, data.length);
    }
  }
}
// confirm，警告，错误提示后执行
export function confirmDo(
  del_title = "",
  title,
  msg,
  btn_cancel_text,
  btn_confirm_text,
  showConfirm = true,
  showCancel = true
) {
  //默认被用来删除
  if (!_this) return false;
  let confirm = null;
  let text_d =
    _this.$t("message_essweb_list_components_tools_delDialogLabel") +
    del_title +
    "？";
  return new Promise((resolve, reject) => {
    confirm = _this.$confirm({
      text: msg ? msg : text_d,
      title: title
        ? title
        : _this.$t("message_essweb_list_components_tools_delDialogTitle"),
      button: [
        {
          text: btn_cancel_text
            ? btn_cancel_text
            : _this.$t("message_essweb_system_tools_dialogCancelBtnLabel"),
          show: showCancel,
          ontap: function () {
            confirm.close();
            resolve(false);
          },
        },
        {
          text: btn_confirm_text
            ? btn_confirm_text
            : _this.$t("message_essweb_system_tools_dialogConfirmBtnLabel"),
          show: showConfirm,
          ontap: function () {
            confirm.close();
            resolve(true);
          },
        },
      ],
    });
  });
}
// confirm，快捷提示，仅用于警告
export function confirmWarn(
  title,
  msg,
  btn_cancel_text,
  btn_confirm_text,
  showConfirm = true,
  showCancel = true
) {
  if (!_this) return false;
  if (title == "refuseChange") {
    //特殊处理来自切换页面判断当前页面是否修改
    title = _this.$t("message_tips");
    msg = _this.$t("message_essweb_form_textField_refuseChange_title");
  }
  let confirm = null;
  return new Promise((resolve, reject) => {
    confirm = _this.$confirm({
      text: msg,
      title: title,
      button: [
        {
          text: btn_cancel_text
            ? btn_cancel_text
            : _this.$t("message_essweb_system_tools_dialogCancelBtnLabel"),
          show: showCancel,
          ontap: function () {
            confirm.close();
            resolve(false);
          },
        },
        {
          text: btn_confirm_text
            ? btn_confirm_text
            : _this.$t("label_essweb_form_tools_oKBtnLabel"),
          show: showConfirm,
          ontap: function () {
            confirm.close();
            resolve(true);
          },
        },
      ],
    });
  });
}
// 图片上传，暂未使用
export function UploadFiles(file_name, file_size) {
  if (!_this) return false;
  return new Promise((res, rej) => {
    _this
      .$Request({
        method: "POST",
        table: "mrbase_sys_attachments",
        url: "/fileManager/add-file-record-plan/",
        data: {
          function_uuid: "upload",
          attachment_title: file_name,
          attachment_size: file_size,
        },
        type: "lang",
      })
      .then((res) => {
        if (res) {
        }
      });
  });
}
//筛选专用，列表筛选，数据操作
export function fliterValue(objects, prop, value, selected) {
  if (!prop && !value) {
    //重置
    objects.map((item) => {
      item["value_save"] = item["type"] == "select" ? [] : "";
      item["value"] = item["type"] == "select" ? [] : "";
    });
  } else {
    let obj = objects.find((ele) => ele["name"].toString() === prop.toString());
    if (!obj) return;
    objects.some((item) => {
      if (item["name"].toString() === prop.toString()) {
        item["value_save"] = item["value"]; // 保存旧值
        item["value"] = value;
        if (selected) item["selected"] = selected;
        return true;
      }
    });
  }
}
// 获取员工专用，数据来自底层接口。由底层维护，用于将树形tree结构转换为列表
export function getStaff(data) {
  let arr = [];
  function get_staff(d) {
    if (d["staff"]) arr = arr.concat(d["staff"]);
    if (d["son_org"]) {
      d["son_org"].map((item) => {
        get_staff(item);
      });
    }
  }
  get_staff(data);
  return arr;
}
//全局加密方法
export function aesEncrypt(data) {
  const cipher = crypto.createCipher("aes192", hmac_key);
  var crypted = cipher.update(data, "utf8", "hex");
  crypted += cipher.final("hex");
  return crypted;
}
//全局解密方法
export function aesDecrypt(encrypted) {
  const decipher = crypto.createDecipher("aes192", hmac_key);
  var decrypted = decipher.update(encrypted, "hex", "utf8");
  decrypted += decipher.final("utf8");
  return decrypted;
}
// 登录加密
export function loginEncrypt({ msg, key }) {
  const pubkey = `-----BEGIN PUBLIC KEY-----${key}-----END PUBLIC KEY-----`;
  const pub = KEYUTIL.getKey(pubkey);
  const enc = KJUR.crypto.Cipher.encrypt(msg, pub);
  // return utf16to8(hextob64(enc))
  return hextob64(enc);
}
//员工搜索，下拉框，根据姓名和员工编号搜索
// var flg = false;
export function staffFilter(item, queryText) {
  if (queryText) {
    // if (flg) {
    //   return true;
    // } else {
    // flg = true;
    //   flg = false;
    let itemText = "preferred_name";
    let itemText2 = "staff_code";
    if (!getCommonLangValue(item[itemText])) return false;
    const one_filter = getCommonLangValue(item[itemText]).toLowerCase();
    const two_filter =
      itemText2 && item[itemText2] !== undefined
        ? getCommonLangValue(item[itemText2]).toLowerCase()
        : "";
    const searchtext = String(queryText).toLowerCase();

    return (
      one_filter.indexOf(searchtext) > -1 || two_filter.indexOf(searchtext) > -1
    );
    // }
  } else return true;
}
//文件大小转换
export function byteconvert(bytes) {
  var i = 0;
  var KBRule = 1024;
  var j = "BKMGT";
  while (bytes > KBRule) {
    bytes = bytes / KBRule;
    i++;
  }
  return bytes.toFixed(2) + j.charAt(i) + (i == 0 ? "" : "B");
}
//延迟执行
export function Sleep(seconds) {
  return new Promise((resolve, reject) => {
    if (!seconds || isNaN(seconds) || Number(seconds) < 0) resolve(seconds);
    setTimeout(() => {
      resolve(seconds);
    }, Number(seconds));
  });
}
//验证Json
export function iSJson(e) {
  if (!e) return e;
  try {
    const f = JSON.parse(e);
    return f;
  } catch (error) {
    return false;
  }
}
